// Sezonski proizvodi u Srbiji po mesecima.
// peakFruits/peakVeg = ono što je na vrhuncu sezone tog meseca.

export const MONTHS_SR = [
  { short: 'Jan', full: 'Januar' },
  { short: 'Feb', full: 'Februar' },
  { short: 'Mar', full: 'Mart' },
  { short: 'Apr', full: 'April' },
  { short: 'Maj', full: 'Maj' },
  { short: 'Jun', full: 'Jun' },
  { short: 'Jul', full: 'Jul' },
  { short: 'Avg', full: 'Avgust' },
  { short: 'Sep', full: 'Septembar' },
  { short: 'Okt', full: 'Oktobar' },
  { short: 'Nov', full: 'Novembar' },
  { short: 'Dec', full: 'Decembar' }
];

export const SEASONAL_DATA = [
  {
    info: 'Malo svežeg sezonskog prinosa — vreme za zimnicu i uskladišteno.',
    fruits: [],
    peakFruits: [],
    veg: ['Kelj', 'Prokelj', 'Praziluk', 'Cvekla', 'Celer', 'Korenje', 'Krompir', 'Kupus'],
    peakVeg: ['Kelj', 'Prokelj']
  },
  {
    info: 'I dalje vladaju korenasto povrće i zimska zelen.',
    fruits: [],
    peakFruits: [],
    veg: ['Kelj', 'Prokelj', 'Praziluk', 'Cvekla', 'Celer', 'Korenje', 'Krompir', 'Kupus'],
    peakVeg: ['Praziluk', 'Kupus']
  },
  {
    info: 'Prve prolećne trave i rani spanać najavljuju sezonu.',
    fruits: [],
    peakFruits: [],
    veg: ['Spanać', 'Mladi luk', 'Rotkvica', 'Kelj', 'Praziluk', 'Korenje', 'Kupus', 'Matovilac'],
    peakVeg: ['Spanać', 'Rotkvica', 'Matovilac']
  },
  {
    info: 'Prolećni bum — rano povrće u punom jeku, prve jagode.',
    fruits: ['Jagode'],
    peakFruits: [],
    veg: ['Spanać', 'Mladi luk', 'Rotkvica', 'Zelena salata', 'Artičoka', 'Grašak', 'Špargle', 'Brokoli'],
    peakVeg: ['Spanać', 'Grašak', 'Špargle']
  },
  {
    info: 'Jagode na vrhuncu, prve trešnje, povrće u izobilju.',
    fruits: ['Jagode', 'Višnje', 'Trešnje'],
    peakFruits: ['Jagode'],
    veg: ['Grašak', 'Brokoli', 'Zelena salata', 'Rotkvica', 'Mladi luk', 'Tikvice', 'Špargle', 'Karfiol'],
    peakVeg: ['Grašak', 'Tikvice']
  },
  {
    info: 'Pravo letnje bogatstvo — trešnje, maline, tikvice, paradajz.',
    fruits: ['Trešnje', 'Višnje', 'Maline', 'Kupine', 'Kajsije', 'Ribizle'],
    peakFruits: ['Trešnje', 'Maline'],
    veg: ['Paradajz', 'Tikvice', 'Krastavac', 'Zelena salata', 'Grašak', 'Paprika', 'Boranija'],
    peakVeg: ['Tikvice', 'Paradajz']
  },
  {
    info: 'Vrhunac leta — breskve, lubenice, svo povrtarsko obilje.',
    fruits: ['Breskve', 'Kajsije', 'Maline', 'Šljive', 'Lubenica', 'Dinja', 'Kupine'],
    peakFruits: ['Breskve', 'Lubenica'],
    veg: ['Paradajz', 'Paprika', 'Krastavac', 'Tikvice', 'Patlidžan', 'Boranija', 'Kukuruz'],
    peakVeg: ['Paradajz', 'Paprika', 'Krastavac']
  },
  {
    info: 'Šljive i grožđe dolaze, lubenice i paprike na vrhuncu.',
    fruits: ['Šljive', 'Grožđe', 'Breskve', 'Lubenica', 'Dinja', 'Kruške'],
    peakFruits: ['Šljive', 'Grožđe'],
    veg: ['Paradajz', 'Paprika', 'Patlidžan', 'Tikvice', 'Kukuruz', 'Krastavac', 'Boranija'],
    peakVeg: ['Paprika', 'Patlidžan']
  },
  {
    info: 'Jesen počinje — jabuke, kruške, grožđe i berba za zimnicu.',
    fruits: ['Jabuke', 'Kruške', 'Grožđe', 'Šljive', 'Dunje'],
    peakFruits: ['Jabuke', 'Grožđe'],
    veg: ['Paradajz', 'Paprika', 'Patlidžan', 'Tikva', 'Cvekla', 'Kupus', 'Karfiol'],
    peakVeg: ['Tikva', 'Kupus']
  },
  {
    info: 'Kasna jesen — dunje, jabuke, korenasto povrće i tikve.',
    fruits: ['Jabuke', 'Kruške', 'Dunje', 'Šipak'],
    peakFruits: ['Jabuke', 'Dunje'],
    veg: ['Cvekla', 'Kupus', 'Prokelj', 'Karfiol', 'Tikva', 'Korenje', 'Celer'],
    peakVeg: ['Cvekla', 'Tikva', 'Korenje']
  },
  {
    info: 'Kraj sezone, berba završena, vreme korenastog povrća.',
    fruits: ['Jabuke', 'Dunje', 'Šipak'],
    peakFruits: [],
    veg: ['Kelj', 'Prokelj', 'Praziluk', 'Cvekla', 'Korenje', 'Kupus', 'Celer'],
    peakVeg: ['Kelj', 'Prokelj', 'Praziluk']
  },
  {
    info: 'Zimska zimnica — sveže iz bašte gotovo nestaje.',
    fruits: [],
    peakFruits: [],
    veg: ['Kelj', 'Prokelj', 'Kupus', 'Praziluk', 'Cvekla', 'Celer', 'Korenje'],
    peakVeg: ['Kupus', 'Praziluk']
  }
];

export const getCurrentMonthIndex = () => new Date().getMonth();
